/**
 * A class for letting users unit vibrate and beep.
 */
class Output {

    private readonly soundCheckboxId:string;
    private readonly vibrateCheckboxId:string;
    private readonly audio:AudioContext;
    private readonly vibrationSupported:boolean;

    /**
     *
     * @param vibrateCheckboxId The ID of the checkbox that must be checked for vibration to be turened on.
     *                   If not given, then vibrate will always be on.
     * @param soundCheckboxId
     */
    constructor(vibrateCheckboxId?:string|null, soundCheckboxId?:string|null) {
        if (soundCheckboxId!==undefined || soundCheckboxId==null) {
            this.soundCheckboxId = soundCheckboxId;
        }
        if (vibrateCheckboxId!==undefined || vibrateCheckboxId==null) {
            this.vibrateCheckboxId = vibrateCheckboxId;
        }
        if (this.audio===undefined) {
            this.audio = new AudioContext();
        }
        this.vibrationSupported = !!window.navigator.vibrate; // detect if vibration is supported
    }

    /**
     * Check if vibrate is turened on
     * @private
     */
    private isSoundOn() {
        return this.soundCheckboxId==undefined || $("#"+this.soundCheckboxId).is(":checked");
    }

    private isVibrationOn() {
        return this.vibrateCheckboxId==undefined || $("#"+this.vibrateCheckboxId).is(":checked");
    }

    /**
     * Play vibration saying operation was OK
     */
    public vibrateOk() {
        if (this.vibrationSupported && this.isVibrationOn()) {
            navigator.vibrate(50);
        }
    }

    public vibrateNothingFound() {
        if (this.vibrationSupported && this.isVibrationOn()) {
            navigator.vibrate(100);
        }
    }

    /**
     * Plays a beep
     * @param volume
     * @param frequency
     * @param duration
     * @private
     */
    private beep(volume, frequency, duration) {
        let v=this.audio.createOscillator()
        let u=this.audio.createGain()
        v.connect(u)
        v.frequency.value=frequency
        v.type="square"
        u.connect(this.audio.destination)
        u.gain.value=volume*0.01
        v.start(this.audio.currentTime)
        v.stop(this.audio.currentTime+duration*0.001)
    }

    public beepOk() {
        if (this.isSoundOn()) {
            this.beep(100, 520, 100);
        }
    }

    public beepError() {
        if (this.isSoundOn()) {
            this.beep(100, 300, 200);
        }
    }

    public isVibrationSupported():boolean {
        return this.vibrationSupported;
    }

}